import type { ReactNode } from 'react';

type Cell = { title?: string; time?: string } | null;

const DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;

/** Weekly grid matching the official Delta BJJ schedule table (print / download). */
const ROWS: Cell[][] = [
  [
    { title: 'BJJ Fundamentals', time: '6:00-7:00am' },
    null,
    { title: 'BJJ Fundamentals', time: '6:00-7:00am' },
    { title: 'NO GI BJJ', time: '6:00-7:00am' },
    null,
    { title: 'Juniors 2 BJJ', time: '10:00-10:50am' },
    { title: 'BJJ Fundamentals', time: '9:00-10:00am' },
  ],
  [
    { title: 'BJJ Fundamentals', time: '11am-12pm' },
    { title: 'NO GI BJJ', time: '11am-12pm' },
    { title: 'BJJ Fundamentals', time: '11am-12pm' },
    { title: 'BJJ Fundamentals', time: '11am-12pm' },
    { title: 'NO GI BJJ', time: '11am-12pm' },
    { title: 'BJJ All Levels', time: '11am-12pm' },
    null,
  ],
  [
    null,
    { title: 'Juniors 1 BJJ', time: '3:35-4:20PM' },
    { title: 'Juniors 1 BJJ', time: '4:15-5:00PM' },
    { title: 'Juniors 1 BJJ', time: '4:35-5:20PM' },
    null,
    null,
    null,
  ],
  [
    { title: 'TEEN BJJ', time: '5:10-6:00PM' },
    { title: 'Juniors 2 BJJ', time: '5:30-6:20pm' },
    { title: 'Juniors 2 BJJ', time: '5:10-6:00pm' },
    { title: 'Juniors 2 BJJ', time: '5:30-6:20pm' },
    { title: 'TEEN BJJ', time: '5:10-6:00PM' },
    null,
    null,
  ],
  [
    { title: 'BJJ Drills for Beginners', time: '6:10-7:00pm' },
    { title: 'Advanced Competition Training', time: '6:30-7:20pm' },
    { title: 'BJJ Drills for Beginners', time: '6:10-7:00pm' },
    { title: 'Situational BJJ Drills', time: '6:30-7:20pm' },
    { title: 'NO GI BJJ', time: '6:00-7:00pm' },
    null,
    null,
  ],
  [
    { title: 'BJJ ALL LEVELS', time: '7:00-8:00pm' },
    { title: 'BJJ Fundamentals', time: '7:30-8:30pm' },
    { title: 'BJJ ALL LEVELS', time: '7:00-8:00pm' },
    { title: 'Advanced BJJ', time: '7:30-8:30pm' },
    null,
    null,
    null,
  ],
];

function ScheduleCell({ cell, extra }: { cell: Cell; extra?: ReactNode }) {
  if (!cell && !extra) {
    return <span className="text-gray-400 text-lg leading-none">-</span>;
  }
  return (
    <div className="space-y-0.5">
      {cell?.title && <div className="font-semibold text-[11px] sm:text-xs md:text-sm leading-tight">{cell.title}</div>}
      {cell?.time && <div className="text-[10px] sm:text-xs text-gray-600">{cell.time}</div>}
      {extra}
    </div>
  );
}

export const WEEKLY_SCHEDULE_TABLE_ID = 'delta-bjj-weekly-schedule-table';

export default function WeeklyScheduleTable() {
  return (
    <div
      id={WEEKLY_SCHEDULE_TABLE_ID}
      className="bg-white text-brand-black border-[3px] border-[#2f6f91] p-4 sm:p-6 md:p-8 select-none"
    >
      <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-4 sm:mb-6">
        DELTA BJJ
      </h2>
      <div className="overflow-x-auto -mx-1 px-1">
        <table className="w-full min-w-[640px] border-collapse text-center text-brand-black">
          <thead>
            <tr>
              {DAYS.map((day) => (
                <th
                  key={day}
                  className="border border-gray-300 px-1 py-2 sm:px-2 sm:py-3 text-[10px] sm:text-xs md:text-sm font-bold"
                >
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, colIndex) => (
                  <td
                    key={`${rowIndex}-${colIndex}`}
                    className="border border-gray-300 align-top px-1 py-2 sm:px-2 sm:py-3 min-h-[56px] text-[11px] sm:text-xs"
                  >
                    {rowIndex === 2 && colIndex === 1 ? (
                      <ScheduleCell
                        cell={cell}
                        extra={
                          <div className="mt-2 pt-2 border-t border-gray-200">
                            <div className="font-semibold text-[11px] sm:text-xs leading-tight">Juniors 1 BJJ</div>
                            <div className="text-[10px] sm:text-xs text-gray-600">4:35-5:20PM</div>
                          </div>
                        }
                      />
                    ) : (
                      <ScheduleCell cell={cell} />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-center text-[10px] sm:text-xs text-gray-500 mt-4 tracking-widest uppercase">
        Weekly class schedule
      </p>
    </div>
  );
}
